<template>
    <div class="user_content_blcok">
        <div class="user_content_blcok_title">
            分享推广
        </div>
        <div class="user_content_blcok_line"></div>

        <div class="user_safe">
            <div class="user_safe_item">
                <div class="user_safe_icon">
                    <i class="font iconfont success">&#xe618;</i>
                </div>
                <div class="user_safe_title">
                    邀请注册链接
                    <p v-if="info.link">{{info.link}}</p>
                </div>
                <div class="user_safe_btn">
                    <div @click="copy()" class="inviter_link" :data-clipboard-text="info.link">复制链接</div>
                </div>
                <div class="clear"></div>
            </div>

            <div class="qrcode">
                <div class="title">推广二维码：</div>
                <div class="myimg img_width">
                    <vue-qr style="border:1px solid #efefef" :logoSrc="imageUrl" :text="info.mlink" :size="200"></vue-qr>
                    </div>
            </div>

            <!-- <div class="qrcode">
                <div class="title">推广海报：</div>
                <div class="myimg">
                    <el-image :src="info.poster" lazy></el-image>
                </div>
            </div> -->

        </div>
        <div class="user_content_blcok_title">
            推广记录
        </div>
        <div class="user_content_blcok_line"></div>
                
        <div class="admin_table_main">
                <el-table :data="list" >
                    <!-- <el-table-column type="selection"></el-table-column> -->
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <!-- <el-table-column prop="id" label="#"  width="70px"></el-table-column> -->
                    <el-table-column label="ID" prop="log_no">
                        <template slot-scope="scope">
                            <div>{{scope.row.userId}}</div>
                        </template> 
                    </el-table-column>
                    <el-table-column label="账号" prop="name">
                        <template slot-scope="scope">
                            <div>{{scope.row.userId}}</div>
                        </template> 
                    </el-table-column>
                    <el-table-column label="用户名" prop="money"></el-table-column>
                    <el-table-column label="注册时间">
                        <template slot-scope="scope">
                            <div>{{scope.row.createtime|formatDate}}</div>
                        </template> 
                    </el-table-column>
                    
                    <!-- <el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.goods.id)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="home_fy_block" style="margin-top:40px;" >
<el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total" :pageSize="pageSize" :pageNum="pageNum"></el-pagination>
                </div>
            </div>



    </div>
</template>

<script>
import Clipboard from 'clipboard';  
import vueQr from 'vue-qr';
import {formatDate} from '@/utils/date';
export default {
    components: {vueQr},
    props: {},
    data() {
      return {
          info:{
              link:'',
            //   qrcode:'',
            //   poster:'',
              user_id:0,
          },
          pageSize:20,
          pageNum:0,
      };
    },
    watch: {
        
    },
    filters: {
      formatDate(time) {
        if (time == null || time === '') {
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      },
      formatTime(time){
        if(time==null||time===''){
          return '';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy-MM-dd')
      },
    },
    computed: {},
    methods: {
        get_info:function(){
            // this.info.link = window.location.host+'/user/register?inviter_id=2';
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                // this.info.qrcode = res.data.qrcode;
                // this.info.poster = res.data.poster;
                this.info.user_id = res.data.id;
                // this.info.link = window.location.host+'/user/register?inviter_id='+this.info.user_id;
                this.info.link = this.$weburl + 'user/register?inviter_id=' + this.info.user_id;
                this.info.mlink = this.$mweburl + 'login?inviter_id=' + this.info.user_id;
                this.imageUrl = 'https://www.sckxyy.com/imgs/imgs/WeChat/loginIco.png';
            })
        },
        copy:function(){
            var clipboard = new Clipboard('.inviter_link');
            clipboard.on('success', () => {  
                this.$message.success("复制成功");//这里你如果引入了elementui的提示就可以用，没有就注释即可
                  // 释放内存  
                  clipboard.destroy()  
            });
            clipboard.on('error', () => { 
                this.$message.error("不支持"); 
                // 不支持复制  
                // 释放内存  
                clipboard.destroy()  
            }); 
            
        },

        // 分页改变
        current_change:function(e){
            this.pageNum = e;
            this.getReferrerList();
            this.$scrollTo();
        },

        getReferrerList:function(){
            this.$get(this.$api.getReferrerList,{pageSize:this.pageSize,pageNum:this.pageNum,platId:this.$platId}).then(res=>{
                this.total = res.data.total;
                this.pageNum = res.data.pageNum;
                this.list = res.data.list;
            })

        },
        
    },
    created() {   
        this.get_info();
        this.getReferrerList();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.user_safe{
    margin-bottom: 20px;
    .qrcode{
        margin-top:20px;
        .myimg{
            margin-top: 20px;
            margin-left: 20%;
        }
        .img_width{
            width: 150px;
        }
    }
    .user_safe_item{
        border-bottom: 1px solid #efefef;
        .user_safe_icon{
            line-height: 90px;
            margin-right: 40px;
            margin-left: 15px;
            float: left;
            i{
                font-size: 34px;
                color: #409EFF; //42b983  ca151e
                
            }
            i.success{
                color: #409EFF;
            }
        }
        .user_safe_title{
            float: left;
            font-size: 16px;
            font-weight: bold;
            padding-top: 20px;
            line-height: 25px;
            p{
                font-size: 14px;
                color:#999;
                font-weight: normal;
            }
        }
        .user_safe_btn{
            float: right;
            margin-top: 28px;
            margin-right: 15px;
            div{
                border: 1px solid #efefef;
                width: 100px;
                line-height: 30px;
                background: #fff;
                text-align: center;
            }
            div:hover{
                border-color:#409EFF;
                color:#409EFF;
            }
        }
    }
}

</style>
<style scoped>
.inviter_link{
    cursor: pointer;
}
</style>